function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9 0l2.645 5.36 5.915.859-4.28 4.172 1.01 5.89L9 13.5l-5.29 2.781 1.01-5.89L.44 6.219l5.915-.86L9 0z",
  fill: "#0085FF"
});
function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    fill: "none"
  }, props), _ref);
}
export default SvgStar;